import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-grade-group';

const getGradeGroups = (merchantId, params = {}) => {
	return Client.get(`${baseUrl}/${merchantId}/groups`, params);
};

const getGradeGroup = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/groups/${id}`);
};

const createGradeGroup = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/groups`, data);
};

const updateGradeGroup = (merchantId, id, data) => {
	return Client.put(`${baseUrl}/${merchantId}/groups/${id}`, data);
};

const deleteGradeGroup = (merchantId, id) => {
	return Client.delete(`${baseUrl}/${merchantId}/groups/${id}`);
};

export default {
	getGradeGroups,
	getGradeGroup,
	createGradeGroup,
	updateGradeGroup,
	deleteGradeGroup,
};
